import { createFileRoute } from "@tanstack/react-router";
import { ProviderKeysPage } from "../components/settings/ProviderKeysPage";

export const Route = createFileRoute("/settings/provider-keys")({
  component: ProviderKeysPage,
});
